export default {
  "meta-title": "TARISLAND",
  "meta-description": "Tarisland is a classic MMORPG on PC and mobile devices, featuring raids, diverse classes, crossplay and a vast world for exploration. Embark on your epic adventure together.",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "Tarisland Official Website",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "Tarisland Official Website",
  "meta-og-title": "Tarisland Official Website",
  "meta-og-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "Tarisland Official Website",
  "meta-twitter-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",

  "email_illegal": "Incorrect Email address. Please check and resubmit it.",
  "horizon_tip": "For a better experience, please rotate your device.",

  'downloadPc': "Please download on PC",

  "area": "Область",
  "select-area": "Выберите область",
  "server": "Сервер",
  "select-server": "Выберите сервер",
  "character-name": "Имя персонажа",
  "select-character": "Выберите персонажа",
  "please-select": "Выберите",
  "not-found-role": "Информация о персонаже не найдена",
  'loading': '加載中....',
  'pls_input_info': '請輸入您的登錄信息。',

  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "Стань моим партнером по Tarisland прямо сейчас!\nНажми:",
  "copy_clipboard-text2": "(эксклюзивная ссылка)\nЕсли ссылка не работает, можешь ввести код приглашения:",
  "friends-completed": "Прошедших друзей",
  "no-friends-completed": "Прошедших друзей: нет",
  "pop_invitedlist_s": "ПРОЙДЕНО",
  "pop_invitedlist_f": "НЕ ПРОЙДЕНО",

  "gift3": "Набор роста С1",
  "gift5": "Дух морозного волка (постоянный)",
  "gift6": "Дух морозного волка (1 день)",
  "gift1": "Подарочная карта на 100$",
  "gift2": "Подарочная карта на 50$",
  "gift4": "Дух пиро-тигра (постоянный)",

  "invite_link_upper_limit": "Извините, эта пригласительная ссылка уже использована максимальное количество раз.",
  "invite_link_disabled": "Неверная ссылка приглашения или просроченный код. Уточните этот информацию у приглашающего.",
  "enter_your_invitation_code": "Введите код приглашения",
  "act_not_start": "Событие не началось.",
  "act_finished": "Событие закончилось.",
  "download_pc": "Загрузите на ПК",
  "email_error": "Неверный адрес эл. почты. Перепроверьте.",
  "loadding": "Загрузка...",
  "check_my_raffle_history": "История розыгрышей",
  "no_raffle_history": "Нет истории розыгрышей",
  "system-error": "Системная ошибка",
  "cant-invite-self": "Нельзя пригласить самого себя",
}